import { EuiBadge } from "@elastic/eui";
import React from "react";

interface RoleBadgeProps {
    role: string;
}

const RoleBadge = ({ role }: RoleBadgeProps) => {
    const getBadgeColor = (roleName: string) => {
        switch (roleName?.toLowerCase() ?? "") {
            case "admin":
                return "danger";
            case "employee":
                return "primary";
            default:
                return "default";
        }
    };

    return <EuiBadge color={getBadgeColor(role)}>{role}</EuiBadge>;
};

export default RoleBadge;
